var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4521 0.205146C10.7695 -0.0727846 11.251 -0.068314 11.563 0.218575L21.7379 9.57399C21.9856 9.80176 22.0668 10.1556 21.9425 10.4662C21.8182 10.7767 21.5138 10.9809 21.175 10.9809H19.2867V18.1871C19.2867 18.636 18.9173 18.9999 18.4617 18.9999H13.035C12.5794 18.9999 12.2101 18.636 12.21 18.1871V12.9857H9.79008V18.1871C9.79008 18.636 9.42074 18.9999 8.96512 18.9999L3.53845 19C3.31964 19 3.10981 18.9144 2.95509 18.762C2.80037 18.6095 2.71342 18.4028 2.71342 18.1873V10.9811H0.82503C0.486171 10.9811 0.18176 10.777 0.0574976 10.4664C-0.0667577 10.1559 0.0143939 9.80204 0.262102 9.57427L10.4372 0.218575L10.4521 0.205146ZM2.91803 9.35566H3.53842C3.99404 9.35566 4.3634 9.71954 4.36341 10.1684V17.3745L8.1401 17.3744V12.173C8.1401 11.7241 8.50946 11.3603 8.96509 11.3603H13.035C13.4907 11.3603 13.86 11.7241 13.86 12.173V17.3744H17.6367V10.1681C17.6367 9.71928 18.0061 9.35541 18.4617 9.35541H19.082L11 1.92444L2.91803 9.35566Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.c20055b05ff18fb065cecc6ea6feedf1.svg";
export { ForwardRef as ReactComponent };